export default "__VITE_ASSET__68663d5a__"